
import {
  Component, Prop, Vue,
} from 'nuxt-property-decorator'
import IMapLocation from '../../shared/general/interfaces/IMapLocation'
import BaseGridLayout from '../layouts/BaseGridLayout.vue'
import IContactElement from '../../shared/general/interfaces/IContactElement'
import BaseHeadline from '../base/BaseHeadline.vue'
import { globalLabelAsString } from '../../shared/general/services/StoreService'
import { setOne } from '../../shared/general/services/privacy/PrivacySettingsService'

@Component({
  name: 'DirectionMap',
  components: {
    BaseHeadline,
    BaseGridLayout,
    Overlay: () => import('./Overlay.vue'),
    GoogleMap: () => import('./GoogleMap.vue'),
    CookieLayer: () => import('../CookieLayer.vue'),
    MapsReplacer: () => import('../MapsReplacer.vue'),
  },
})
export default class DirectionMap extends Vue {
  @Prop({ required: true }) zoomLevel! : number

  @Prop({ required: true }) geoCoordinates! : IMapLocation

  @Prop({ required: false }) headline! : string

  @Prop({ required: true }) locationInfo! : IContactElement[]

  @Prop({ required: true }) googleMapsApiKey! : string

  private get cookiesAccepted () : boolean {
    return this.$store.state.PrivacySettings.settings.google_maps
  }

  private get googleMapsRedirectLink () : string {
    return `https://www.google.com/maps/search/?api=1&query=${this.geoCoordinates.lat},${this.geoCoordinates.lng}`
  }

  private get googleMapsExternalLinkLabel () : string {
    return globalLabelAsString('open_maps_external_label')
  }

  private get noVideoAcceptLabel () : string {
    return globalLabelAsString('accept_cookies')
  }

  private redirectToGoogleMaps () : void {
    window.open(this.googleMapsRedirectLink, '_blank')
  }

  private acceptCookies () : void {
    setOne('google_maps', true)
  }
}
